import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const teamColors = ['#00e676', '#ff5722', '#2196f3', '#e91e63'];

const CountryBattleResult = ({ winner, teamCounts, selectedTeams, prediction, onPlayAgain }) => (
  <div className="result-screen">
    <motion.div
      className="result-container"
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
    >
      <h2 className="result-title">🏆 WINNER 🏆</h2>

      {winner && winner.flag && (
        <div className="winner-display">
          <div className="winner-flag-card">
            <motion.img
              src={winner.flag}
              alt={winner.name}
              className="winner-flag"
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: 'backOut' }}
            />
          </div>
          <motion.h1
            className="winner-name"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {winner.name}
          </motion.h1>
        </div>
      )}

      {/* Final Scores for all teams */}
      <div className="final-score-multi">
        {selectedTeams.map((team, index) => (
          <div
            key={team.id}
            className={`final-team-item ${winner?.id === team.id ? 'winner' : ''}`}
            style={{ borderColor: winner?.id === team.id ? '#ffd700' : teamColors[index] }}
          >
            <div className="final-team-flag-wrap">
              <img src={team.flag} alt={team.name} />
            </div>
            <span className="team-name">{team.name}</span>
            <span
              className="final-count"
              style={{ color: winner?.id === team.id ? '#ffd700' : teamColors[index] }}
            >
              {teamCounts[team.id] || 1} flags
            </span>
          </div>
        ))}
      </div>

      {prediction && (
        <div
          className={`prediction-result ${
            prediction === winner?.id ? 'correct' : 'incorrect'
          }`}
        >
          {prediction === winner?.id
            ? '🎉 YOUR PREDICTION WAS CORRECT! 🎉'
            : '😔 BETTER LUCK NEXT TIME!'}
        </div>
      )}

      <div className="result-actions">
        <button className="play-again-btn" onClick={onPlayAgain}>
          <span>🔄</span> PLAY AGAIN
        </button>
        <Link
          to="/"
          className="inline-flex items-center border border-white/30 text-white hover:bg-white/10 hover:border-white/50 font-medium text-sm px-4 py-2 rounded transition-all backdrop-blur-sm"
          style={{ textTransform: 'none' }}
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="sm:hidden">Back</span>
          <span className="hidden sm:inline">Back to Home</span>
        </Link>
      </div>
    </motion.div>
  </div>
);

export default CountryBattleResult;
